import { render, staticRenderFns } from "./TaskNotes.vue?vue&type=template&id=785aa077&"
import script from "./TaskNotes.vue?vue&type=script&lang=js&"
export * from "./TaskNotes.vue?vue&type=script&lang=js&"
import style0 from "./TaskNotes.vue?vue&type=style&index=0&id=785aa077&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports